import { InitialConfig } from '../typings/initial';

class Config implements InitialConfig {
  public apiUrl: string;

  public facebookUrl: string;

  public priceListUrl: string;
  public contactsUrl: string;
  public newsUrl: string;

  public oaCrmApplicationName: string;
  public oaCrmEnvironmentName: 'live' | 'test' | 'dev';
  public headerEnvironmentName: 'live' | 'test' | 'dev';
  public headerRedirectUrl: string;

  public ssoClientEnvironment: 'dev' | 'test' | 'live';

  paymentFrontendEnvironmentName: 'live' | 'test' | 'dev';

  private initialized = false;

  public initialize(config: InitialConfig) {
    if (this.initialized) {
      throw new Error('Configuration already initialized');
    }
    Object.keys(config).forEach((key) => {
      (this as any)[key] = (config as any)[key];
    });
    this.initialized = true;
  }
}

export default new Config();
